import { render, staticRenderFns } from "./bgStyle.vue?vue&type=template&id=b84e28fe&scoped=true"
import script from "./bgStyle.vue?vue&type=script&lang=js"
export * from "./bgStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84e28fe",
  null
  
)

export default component.exports